import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  filter: {
    companyId: number
    clientIds?: Array<number>
    cameraIds?: Array<number>
    status?: Array<string>
  }
  start: string
  end: string
  aggregateBy: 'client' | 'camera'
}

export default function useDashboardCountByCamera({filter, aggregateBy, start, end}: Props) {
  const query = useQuery({
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_EVENTS_COUNT_BY_CAMERA, filter, aggregateBy, start, end],
    queryFn: async () => (await api.reports.countByCamerasReports({filter, aggregateBy, orderBy: 'DESC', start, end})).data.data,
  })

  return query
}
